import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-forward-up', 'IconArrowForwardUp', [
  ['path', { d: 'M15 14l4 -4l-4 -4', key: 'svg-0' }],
  ['path', { d: 'M19 10h-11a4 4 0 1 0 0 8h1', key: 'svg-1' }],
]);
